import { Check } from '@chain-zen/ui'

import type { TTiveDeviceSource } from '../../../types/tracking'
import { RemoveTiveDevice } from '../remove-tive-device'
import { TiveIcon } from '../tive-icon'
import { TrackingSourceRow } from '../tracking-source-row'
import { TrackingTimeDisplay } from '../tracking-time-display'

interface ITiveDeviceInfoProps {
  shipmentID: string
  trackingSourceData: TTiveDeviceSource
}

/**
 * Displays the details for tive device
 */
export const TiveDeviceInfo = (props: ITiveDeviceInfoProps) => {
  const { trackingSourceData, shipmentID } = props
  const lastLocation =
    trackingSourceData?.locations && trackingSourceData.locations.length > 0
      ? trackingSourceData.locations[trackingSourceData.locations.length - 1]
      : null

  return (
    <TrackingSourceRow
      className="px-2 group"
      actions={
        <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-opacity">
          <RemoveTiveDevice shipmentID={shipmentID} tiveDeviceID={trackingSourceData.metadata?.tiveDeviceID || ''} />
        </div>
      }
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1 flex-wrap">
          <Check className="h-3 w-3 shrink-0 self-center text-green-500 dark:text-green-400" />
          <TiveIcon size={3} />
          <span className="text-sm font-medium text-foreground">
            {trackingSourceData?.metadata?.provider || 'Tive Device'}
          </span>
          {!!lastLocation && (
            <TrackingTimeDisplay
              filterReason={trackingSourceData.filterReason}
              lastLocationCity={lastLocation.city}
              lastLocationFetchedAt={trackingSourceData.lastLocationFetchedAt}
              lastLocationStateCode={lastLocation.stateCode}
              lastLocationTimestamp={lastLocation.timestamp}
              wrapper="div"
              className="text-xs text-muted-foreground"
            />
          )}
        </div>

        <div className="flex items-center gap-1 text-xs text-muted-foreground flex-wrap">
          <span>Device ID: {trackingSourceData?.metadata?.tiveDeviceID}</span>
        </div>
      </div>
    </TrackingSourceRow>
  )
}
